import { useCommonComponentContext } from "@maysoft/common-component-react";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { DefaultTheme as Theme } from "@mui/system";

import theme from "../assets/theme";
import Global from "../commons/global";
import { MaterialUIControllerProvider } from "../components/context";

import { useEffect } from "react";
import { setLocale } from "yup";
import Strings from "../constants/strings";
import "../styles/main.css";
import "../styles/muiIcon.css";

export const CircleCommonProvider = (props: { children: React.ReactNode; theme?: Partial<Theme> | ((outerTheme: Theme) => Theme) }) => {
    const { axios, language } = useCommonComponentContext();
    Global.axios = axios as any;

    useEffect(() => {
        Strings.setLanguage(language);
        setLocale({
            // use constant translation keys for messages without values
            mixed: {
                required: Strings.Validation.REQUIRED,
            },
            string: {
                email: Strings.Validation.EMAIL_ADDRESS,
            },
        });
    }, [language]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={props.theme || theme}>
                <MaterialUIControllerProvider>
                    <CssBaseline />
                    {props.children}
                </MaterialUIControllerProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};
